export default "__VITE_ASSET__Cn5mRC2F__"